// 应用配置
export const config = {
  // 应用标题
  title: '应急科技推介平台',
  
  // API基础地址 - 从环境变量获取，支持开发和生产环境
  // 注意：协议检测在request.js的拦截器中动态执行，因为模块加载时window可能未准备好
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  
  // PC端URL配置（用于跳转到PC端）
  pcBaseUrl: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:8080'  // 开发环境
    : 'https://www.zgyjkj.com',  // 生产环境
  
  // 请求超时时间（60秒，适用于可能耗时较长的请求）
  timeout: 60000,
  
  // 分页配置
  pagination: {
    pageSize: 10,
    pageSizes: [10, 20, 50, 100]
  },
  
  // 文件上传配置
  upload: {
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
    action: '/upload'
  },
  
  // 主题配置
  theme: {
    primaryColor: '#667eea',
    secondaryColor: '#764ba2'
  }
}

// 开发环境配置
export const devConfig = {
  ...config,
  debug: true,
  mock: false
}

// 生产环境配置
export const prodConfig = {
  ...config,
  debug: false,
  mock: false
}

// 导出当前环境配置
export default process.env.NODE_ENV === 'development' ? devConfig : prodConfig



